<template>
  <div>
    <!-- <v-row class="mt-0">
      <v-col cols="12" class="pb-0">
        <v-btn color="secondary"  icon @click.stop="getCampaigns()">
          <i class="fa fa-repeat"></i>
        </v-btn>
        <v-btn @click="resetFilter" class="ml-2"  style="float: right">Reset Filters</v-btn>
      </v-col>
    </v-row> -->
    
    <v-row class="mb-3 mt-3" style="justify-content:right">
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-card-title class="pa-0">
          <v-row class="filter-area">
            <v-col cols="12" sm="12" md="6" lg="6">
              <!-- Reload button aligned left -->
              <v-btn color="secondary" small class="mb-2" @click.stop="resetFilter()" style="margin-left: 0;">
                <i class="fa fa-repeat fa-xs"></i>&nbsp;Reload
              </v-btn>
            </v-col>
            <!-- <v-col cols="12" sm="12" md="1" lg="1" style="min-width:150px">
              <v-checkbox
                class="mt-0"
                v-model="selectedFilter.locked"
                label="Locked COGS"
                color="secondary"
                :value="false"
                hide-details
                @change="searchFilter"
              ></v-checkbox>
            </v-col> -->
            <v-col cols="12" sm="12" md="2" lg="2">
              <v-autocomplete
                :items="AM"
                item-value="id"
                item-text="name"
                label="AM"
                v-model="selectedFilter.AM"
                hide-details
                outlined
                dense
                @change="searchFilter"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="2" lg="2">
              <v-autocomplete
                :items="CC"
                item-value="id"
                item-text="name"
                label="CC"
                v-model="selectedFilter.CC"
                hide-details
                outlined
                dense
                @change="searchFilter"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="2" lg="2">
              <v-select
                style="max-width:200px;"
                :items="defaultYears"
                label="Active Year"
                v-model="selectedFilter.activeYear"
                outlined
                dense
                hide-details
                @change="getCampaignCogs()"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-title>
      </v-col>
    </v-row>
    <!-- Summary Boxes -->
    <v-layout row wrap class="mt-0" v-if="totalSummary">
      <v-flex md3 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="150px">
          <v-card-title class="title card-title one-line">Q1</v-card-title>
          <v-card-text v-if="summaryItems.length">
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
            <span>Total Entries:</span><span>{{summaryItems[0].data.length}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>Total COGS Capped:</span>
              <span>${{summaryItems[0].totalValues.cappedCOGS | thousandSeprator}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>Total COGS Used:</span>
              <span>${{summaryItems[0].totalValues.cogsTotal | thousandSeprator}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>Total COGS Excess:</span>
              <span>${{summaryItems[0].totalValues.cogsExcess | thousandSeprator}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>COGS %:</span>
              <span>{{summaryItems[0].totalValues.cogsInfPercentage}}%</span>
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="150px">
          <v-card-title class="title card-title one-line">Q2</v-card-title>
          <v-card-text v-if="summaryItems.length">
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
            <span>Total Entries:</span><span>{{summaryItems[1].data.length}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>Total COGS Capped:</span>
              <span>${{summaryItems[1].totalValues.cappedCOGS | thousandSeprator}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>Total COGS Used:</span>
              <span>${{summaryItems[1].totalValues.cogsTotal | thousandSeprator}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>Total COGS Excess:</span>
              <span>${{summaryItems[1].totalValues.cogsExcess | thousandSeprator}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>COGS %:</span>
              <span>{{summaryItems[1].totalValues.cogsInfPercentage}}%</span>
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="150px">
          <v-card-title class="title card-title one-line">Q3</v-card-title>
          <v-card-text v-if="summaryItems.length">
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
            <span>Total Entries:</span><span>{{summaryItems[2].data.length}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>Total COGS Capped:</span>
              <span>${{summaryItems[2].totalValues.cappedCOGS | thousandSeprator}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>Total COGS Used:</span>
              <span>${{summaryItems[2].totalValues.cogsTotal | thousandSeprator}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>Total COGS Excess:</span>
              <span>${{summaryItems[2].totalValues.cogsExcess | thousandSeprator}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>COGS %:</span>
              <span>{{summaryItems[2].totalValues.cogsInfPercentage}}%</span>
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="150px">
          <v-card-title class="title card-title one-line">Q4</v-card-title>
          <v-card-text v-if="summaryItems.length">
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
            <span>Total Entries:</span><span>{{summaryItems[3].data.length}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>Total COGS Capped:</span>
              <span>${{summaryItems[3].totalValues.cappedCOGS | thousandSeprator}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>Total COGS Used:</span>
              <span>${{summaryItems[3].totalValues.cogsTotal | thousandSeprator}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>Total COGS Excess:</span>
              <span>${{summaryItems[3].totalValues.cogsExcess | thousandSeprator}}</span>
            </p>
            <p
              class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
            >
              <span>COGS %:</span>
              <span>{{summaryItems[3].totalValues.cogsInfPercentage}}%</span>
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
      <!-- <v-flex md4 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="150px">
          <v-card-title class="title card-title one-line pb-0">Total Projected for {{currentMonthYear}} (Current Month)</v-card-title>
          <v-card-text class="pb-0">
            <h3 class="pt-3 mb-1">${{roundDec(totalSummary.projectedCogsForMonth) | thousandSeprator}}</h3>
          </v-card-text>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              text
              @click="openProjectedCogsDialog"
            >
              More Details
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex md4 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="150px">
          <v-card-title class="title card-title one-line">Average COGS %</v-card-title>
          <v-card-text>
            <h3>{{roundDec(totalSummary.avgCOGS)}} %</h3>
          </v-card-text>
        </v-card>
      </v-flex> -->
    </v-layout>
    <v-row class="mb-1">
      <v-col class="pt-0" cols="12" sm="12" md="12" lg="12">
        <div class="d-flex flex-row" style="justify-content:space-between">
          <div>
          </div>
          <div class="d-flex flex-row">
            <div style="min-width:150px">
              <v-menu
                ref="startDatePicker"
                v-model="startDateCal"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                dense
                max-width="350px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="Start Month"
                    placeholder="Start Month"
                    v-model="selectedFilter.startDate"
                    dense
                    readonly
                    outlined
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedFilter.startDate"
                  type="month"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                </v-date-picker>
              </v-menu>
            </div>
            <span class="date-divider"> - </span>
            <div style="min-width:150px">
              <v-menu
                ref="endDatePicker"
                v-model="endDateCal"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                dense
                max-width="350px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="mr-3"
                    label="End Month"
                    placeholder="End Month"
                    v-model="selectedFilter.endDate"
                    dense
                    readonly
                    outlined
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedFilter.endDate"
                  type="month"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                </v-date-picker>
              </v-menu>
            </div>
            <div>
              <v-text-field class="pt-0" v-model="selectedFilter.text" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </div>
            <div>
              <v-btn @click="searchFilter" color="secondary" class="ml-2">Apply</v-btn>
            </div>
            <v-menu
              :close-on-content-click="false"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="secondary"
                  v-bind="attrs"
                  v-on="on"
                  @click="openColSettingsModal"
                >
                  <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                </v-btn>
              </template>
            </v-menu>
          </div>
        </div>
        <!-- <v-btn color="success" small class="mb-2" v-if="showEditActions" @click="saveChanges()">Save Changes</v-btn>
        <v-btn color="warning" small class="mb-2" v-if="showEditActions" @click="resetEdit()">Cancel</v-btn> -->
      </v-col>
    </v-row>
    <div class="campaign-cogs-section" :id="item.name" v-for="(item, index) in filteredItems" :key="index">
      <v-expansion-panels class="expansion-panels mb-5" v-model="item.panel" multiple accordion>
        <v-expansion-panel class="expansion-panel-main" expand>
          <v-expansion-panel-header class="expansion-panel-header">
            <h3 class="pa-0 ma-0">{{item.title}}</h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="expansion-panel-content">
            <v-row class="no-gutters">
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-row class="action-section mb-3">
                  <v-col class="action-group-section pl-0" cols="12" sm="3" md="3" lg="3">
                    <div class="d-flex flex-row" style="gap:3px">
                      <div>
                        <v-btn
                          class="mb-2"
                          color="warning"
                          small
                          v-if="item.selectedCOGS && item.selectedCOGS.length > 0"
                          @click="openQuarterUpdateModal(item.selectedCOGS)"
                        >Update Status ({{item.selectedCOGS.length}})</v-btn>
                        <v-btn
                        color="warning"
                        class="mb-2"
                        small
                        v-if="item.selectedCOGS && item.selectedCOGS.length > 0"
                        @click="openActiveYearDialog(item.data)">
                          <v-icon small>edit</v-icon> Update Active Year
                        </v-btn>
                        <v-btn class="mb-2 primary" small @click="exportReport(item)"><v-icon small>mdi-file-excel</v-icon> Export Excel</v-btn>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="9" md="9" lg="9">
                    <div class="d-flex justify-content-right float-right">
                      <div class="mx-2" style="min-width:150px">
                        <v-text-field
                          v-model="item.filter.search"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-data-table
                  :headers="computedHeaders"
                  :search="item.filter.search"
                  :items="item.data"
                  :items-per-page="15"
                  show-select
                  :single-select="false"
                  v-model="item.selectedCOGS"
                  class="cogs-summary-table elevation-1"
                  @current-items="getFiltered">
                  <template v-slot:[`item.campaignName`]="{ item }">
                    <td class="text-xs-left">
                      {{ item.campaignName }}
                      <div v-if="item.lockedCOGS">
                        <v-chip
                        color="warning"
                        x-small
                        text-color="white">
                          <v-icon small>mdi-lock</v-icon> Locked COGS
                        </v-chip>
                      </div>
                    </td>
                  </template>
                  <template v-slot:[`item.budget`]="{ item }">
                    <td class="text-xs-left">${{item.budget | thousandSeprator}}</td>
                  </template>
                  <template v-slot:[`item.cappedCOGS`]="{ item }">
                    <td class="text-center">
                      <span v-if="item.cappedCOGS">${{item.cappedCOGS | thousandSeprator}}</span>
                      <v-chip
                      color="warning"
                      x-small
                      text-color="white"
                      v-if="item.markupDeal">
                        Markup COGS
                      </v-chip>
                    </td>
                  </template>
                  <template v-slot:[`item.cogsTotal`]="{ item }">
                    <td class="text-center">
                      <span v-if="item.cogsTotal">${{item.cogsTotal | thousandSeprator}}</span>
                      <v-chip
                      color="red"
                      x-small
                      text-color="white"
                      v-if="item.cogsTotal && item.cappedCOGS && item.cogsTotal > item.cappedCOGS">
                        Burst COGS
                      </v-chip>
                    </td>
                  </template>
                  <template v-slot:[`item.cogsInf`]="{ item }">
                    <td class="text-center">
                      <span v-if="item.cogsInf">${{item.cogsInf | thousandSeprator}}</span>
                    </td>
                  </template>
                  <template v-slot:[`item.cogsNoGST`]="{ item }">
                    <td class="text-center">
                      <span v-if="item.cogsNoGST">${{item.cogsNoGST | thousandSeprator}}</span>
                    </td>
                  </template>
                  <template v-slot:[`item.cogsOthers`]="{ item }">
                    <td class="text-center">
                      <span v-if="item.cogsOthers">${{item.cogsOthers | thousandSeprator}}</span>
                    </td>
                  </template>
                  <template v-slot:[`item.cogsInfPercentage`]="{ item }">
                    <td class="text-center"><span v-if="item.cogsInfPercentage">{{item.cogsInfPercentage}}%</span></td>
                  </template>
                  <template v-slot:[`item.cogsExcess`]="{ item }">
                    <td class="text-center">
                      <a :class="getCOGSExcessColor(item.cogsExcess)">{{getCOGSExcessSign(item.cogsExcess) | thousandSeprator}}</a>
                    </td>
                  </template>
                  <template v-slot:[`item.completedAmt`]="{ item }">
                    <td class="text-center">
                      <a class="custom-link" :href="'/finance/payment-consolidation/status?id='+item.campaignID" target="_blank">${{item.completedAmt | thousandSeprator}}</a>
                    </td>
                  </template>
                  <template v-slot:[`item.pendingAmt`]="{ item }">
                    <td class="text-center">
                      <a class="custom-link" :href="'/finance/payment-consolidation/status?id='+item.campaignID" target="_blank">${{item.pendingAmt | thousandSeprator}}</a>
                    </td>
                  </template>
                  <template v-slot:[`item.AM`]="{ item }">
                    <td class="text-center">
                      <span v-if="item.AM">
                        {{getUsersDisplay(item.AM)}}
                      </span>
                    </td>
                  </template>
                  <template v-slot:[`item.CC`]="{ item }">
                    <td class="text-center">
                      <span v-if="item.CC">
                        {{getUsersDisplay(item.CC)}}
                      </span>
                    </td>
                  </template>
                  <template v-slot:[`item.startDate`]="{ item }">
                    <div @click="openEditItem(item, 'startDate', 'filteredItems')" v-if="item.startDateEdit === false">
                      <td class="text-center">
                        {{formatMonth(item.startDate)}} <v-icon class="cursor-pointer" color="warning" x-small>edit</v-icon>
                      </td>
                    </div>
                    <div v-else>
                      <td class="text-xs-left" style="min-width:120px">
                        <v-menu
                          v-model="item.startCal"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              class="input-field mt-3"
                              v-model="item.startDate"
                              append-icon="event"
                              readonly
                              dense
                              outlined
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            type="month"
                            v-model="item.startDate"
                            @input="item.startCal = false"
                          ></v-date-picker>
                        </v-menu>
                      </td>
                    </div>
                  </template>
                  <template v-slot:[`item.endDate`]="{ item }">
                    <div @click="openEditItem(item, 'endDate', 'filteredItems')" v-if="item.endDateEdit === false">
                      <td class="text-center">
                        {{formatMonth(item.endDate)}} <v-icon class="cursor-pointer" color="warning" x-small>edit</v-icon>
                      </td>
                    </div>
                    <div v-else>
                      <td class="text-xs-left" style="min-width:120px">
                        <v-menu
                          v-model="item.endCal"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              class="input-field mt-3"
                              v-model="item.endDate"
                              append-icon="event"
                              readonly
                              dense
                              outlined
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            type="month"
                            v-model="item.endDate"
                            @input="item.endCal = false"
                          ></v-date-picker>
                        </v-menu>
                      </td>
                    </div>
                  </template>
                  <template v-slot:[`item.startMonth`]="{ item }">
                    <div>
                      <td class="text-center">
                        {{formatMonth(item.startMonth)}}
                      </td>
                    </div>
                  </template>
                  <template v-slot:[`item.endMonth`]="{ item }">
                    <div>
                      <td class="text-center">
                        {{formatMonth(item.endMonth)}}
                      </td>
                    </div>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <td class="text-center" style="width:170px">
                      <v-btn
                        small
                        color="warning"
                        @click="changeLock(item, false)"
                        v-if="item.lockedCOGS && isAdmin"
                      >
                        <v-icon color="white" small>mdi-lock-open</v-icon> Unlock
                      </v-btn>
                      <v-btn
                        small
                        color="error"
                        @click="changeLock(item, true)"
                        v-if="!item.lockedCOGS && isAdmin"
                      >
                        <v-icon color="white" small>mdi-lock</v-icon> Lock
                      </v-btn>
                      <v-btn
                        small
                        @click="showPairedAdminViewDialog(item)"
                        color="success"
                        class="ims-action"
                        v-if="isAdmin"
                      >
                        <v-icon color="white" small data-toggle="tooltip" data-placement="top" title="View Influencers">people</v-icon>
                      </v-btn>
                      <v-btn color="secondary" small class="mb-2" @click.stop="reloadManually(item.campaignID)">
                        <i class="fa fa-repeat fa-xs"></i>
                      </v-btn>
                      <v-btn
                      class="mb-2"
                      :to="'/influencers/invoices-brief-confirmation?id='+item.campaignID"
                      target="_blank"
                      color="warning"
                      small
                    >
                      <v-icon small>mdi-file-outline</v-icon> Invoices & Brief
                    </v-btn>
                    </td>
                  </template>
                  <!-- Start Footer Area -->
                  <template slot="body.append">
                    <tr>
                      <th class="subtitle-2">Total:</th>
                      <th class="text-center" v-for="(cItem, index) in computedHeaders" :key="index">
                        <v-chip
                          class="summary-chip"
                          small
                          color="primary"
                          text-color="white"
                          v-if="item.totalValues && item.totalValues[cItem.value]"
                        >
                        <v-icon small left class="mr-0">mdi-currency-usd</v-icon> {{item.totalValues[cItem.value] | thousandSeprator}}
                        </v-chip>
                      </th>
                      <!-- <th class="text-center">
                        <v-chip
                          class="summary-chip"
                          small
                          color="primary"
                          text-color="white"
                        >
                        <v-icon small left class="mr-0">mdi-currency-usd</v-icon> {{item.totalValues.cappedCOGS | thousandSeprator}}
                        </v-chip>
                      </th>
                      <th class="text-center">
                        <v-chip
                          class="summary-chip"
                          small
                          color="primary"
                          text-color="white"
                        >
                          <v-icon small left class="mr-0">mdi-currency-usd</v-icon> {{item.totalValues.cogsTotal | thousandSeprator}}
                        </v-chip>
                      </th>
                      <th class="text-center">
                        <v-chip
                          class="summary-chip"
                          small
                          color="primary"
                          text-color="white"
                        >
                        <v-icon small left class="mr-0">mdi-currency-usd</v-icon> {{item.totalValues.cogsInf}}
                        </v-chip>
                      </th>
                      <th class="text-center">
                        <v-chip
                          class="summary-chip"
                          small
                          color="primary"
                          text-color="white"
                        >
                        <v-icon small left class="mr-0">mdi-currency-usd</v-icon> {{item.totalValues.cogsOthers}}
                        </v-chip>
                      </th>
                      <th class="text-center">
                        <v-chip
                          class="summary-chip"
                          small
                          color="primary"
                          text-color="white"
                        >{{item.totalValues.cogsInfPercentage}} %
                        </v-chip>
                      </th>
                      <th class="text-center">
                        <v-chip
                          class="summary-chip"
                          small
                          color="primary"
                          text-color="white"
                        >
                        <v-icon small left class="mr-0">mdi-currency-usd</v-icon> {{item.totalValues.cogsExcess | thousandSeprator}}
                        </v-chip>
                      </th>
                      <th class="text-center">
                        <v-chip
                          class="summary-chip"
                          small
                          color="primary"
                          text-color="white"
                        >
                        <v-icon small left class="mr-0">mdi-currency-usd</v-icon> {{item.totalValues.completedAmt}}
                        </v-chip>
                      </th>
                      <th class="text-center">
                        <v-chip
                          class="summary-chip"
                          small
                          color="primary"
                          text-color="white"
                        >
                        <v-icon small left class="mr-0">mdi-currency-usd</v-icon> {{item.totalValues.pendingAmt}}
                        </v-chip>
                      </th> -->
                    </tr>
                  </template>
                  <!-- End Footer Area -->
                </v-data-table>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
    <paired-inf-admin-view-dialog 
    v-model="pairedInfAdminViewDialog" 
    :value="pairedInfAdminViewDialog"
    :campaign="pairedCampaign"
    :clients="allClients"/>
    <update-quarter-modal
      v-model="quarterUpdateialog" 
      :value="quarterUpdateialog"
      :selectedCOGS="selectedCOGS"
      @updated="getCampaignCogs"
    />
    <table-cols-show-hide-modal
      v-model="colSettingsDialog"
      title="Campaign COGS"
      :items="tableColsItems"
      @updated="updateTableCols"
    />
    <projected-cogs-modal
      v-model="projectedCogsDialog"
      :value="projectedCogsDialog"
      :monthYearValues="totalSummary.revsForMonthYear"
      v-if="totalSummary"
    />
    <active-year-modal
      v-model="activeYearDialog"
      :value="activeYearDialog"
      :items="selectedCOGS"
      :campaigns="editCampaigns"
      @updated="getCampaignCogs"
    />
  </div>
</template>
<script>
import config from '@/config';
import campaignConfig from '../config';
import cogsSummaryConfig from './config';
import DataTableMixin from '@/mixins/DataTableMixin'
import PairedInfAdminViewDialog from '../PairingInfluencer/PairedInfAdminViewDialog';
import UpdateQuarterModal from './UpdateQuarterModal';
import ProjectedCogsModal from './ProjectedCogsModal';
import ActiveYearModal from './ActiveYearModal';
// import campaignHelper from '../campaignHelper';
import userAPIs from '../../User/userAPIs';
import campaignAPIs from '../campaignAPIs';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState } from 'vuex'
import moment from 'moment'
import utils from '@/utils'
import TableColsShowHideModal from '@/components/scoped/custom/TableColsShowHideModal'
const FileSaver = require('file-saver')
export default {
  name: 'CogsSummaryDataTable',
  mixins: [DataTableMixin],
  props: ['refresh'],
  components: {
    Loading,
    PairedInfAdminViewDialog,
    UpdateQuarterModal,
    TableColsShowHideModal,
    ProjectedCogsModal,
    ActiveYearModal
  },
  data() {
    return {
      headers: cogsSummaryConfig.tableHeaders,
      dummyData: cogsSummaryConfig.dummyData,
      items: [],
      filter: '',
      filteredItems: [],
      AM: [],
      CC: [],
      defaultYears: [2026, 2025, 2024, 2023, 2022],
      isLoading: false,
      showEditActions: false,
      campaignTypeDisplayFilter: campaignConfig.campaignTypeDisplay,
      selectedFilter: {
        AM: '',
        CC: '',
        startDate: '',
        endDate: '',
        locked: false,
        text: '',
        activeYear: 2026
      },
      pairedInfAdminViewDialog: false,
      pairedCampaign: null,
      startDate: '',
      endDate: '',
      startDateCal: false,
      endDateCal: false,
      selectedCOGS: [],
      quarterUpdateialog: false,
      tableColsItems: [],
      colSettingsDialog: false,
      colStatuses: {},
      userProfile: {},
      totalSummary: {
        projectedCOGS: 0,
        projectedCogsForMonth: 0,
        avgCOGS: 0,
        revsForMonthYear: []
      },
      summaryItems: [],
      projectedCogsDialog: false,
      activeYearDialog: false,
      editCampaignID: ''
    }
  },
  watch: {
    refresh(value) {
      if (value) this.init()
    }
  },
  computed: {
    ...mapState({
      allClients: state => state.client.clients,
      campaigns: state => state.campaign.campaigns,
      campaignCogs: state => state.campaign.campaignCogs,
      campaignUpdated: state => state.campaign.campaignUpdated
    }),
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    isAdmin: function() {
      return Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_LOW
    },
    computedHeaders() {
      let campaignCogsCols = null
      let headers = Object.assign([], this.headers)
      // set col statuses from user table
      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.campaignCogsCols) {
          campaignCogsCols = Object.assign({}, this.userProfile.tableSettings.campaignCogsCols)
        }
      }
      if (campaignCogsCols) {
        this.colStatuses = Object.assign({}, campaignCogsCols)
      } else {
        // default true if no col status in local storage
        headers.map(header => {
          this.colStatuses[header.value] = true
        })
      }
      return headers.filter(h => {
        if (this.colStatuses[h.value]) {
          return true
        }
        return false
      });
    },
    currentMonthYear: function() {
      return moment().format('MMM YYYY')
    },
    isNotClient() {
      return Number(this.$store.state.user.role) !== config.userRoles.CLIENT
    }
  },
  async mounted() {
    this.init()
    await this.getUserProfile()
  },
  methods: {
    async init() {
      this.isLoading = true
      await this.getUsers()
      // await this.getCampaigns()
      await this.getCampaignCogs()
    },
    // async getCampaigns() {
    //   this.isLoading = true
    //   let payload = {
    //     filters: {
    //       statuses: [
    //         config.campaignStatus.PAIRING_INFLUENCER,
    //         config.campaignStatus.ONGOING
    //       ]
    //     }
    //   }
    //   await this.$store.dispatch('campaign/getCampaigns', payload)
    //   if (this.campaigns) {
    //     this.items = Object.assign([], this.campaigns)
    //     this.beautifyData()
    //     this.searchFilter()
    //   }
    //   this.isLoading = false
    // },
    async getCampaignCogs(reload = false) {
      this.isLoading = true
      let filters = {}
      if (reload) {
        filters.reload = reload
      }
      if (this.selectedFilter.activeYear) {
        filters.activeYear = this.selectedFilter.activeYear
      }
      await this.$store.dispatch('campaign/getCampaignCogs', filters)
      if (this.campaignCogs) {
        this.items = Object.assign([], this.campaignCogs)
        this.searchFilter()
      }
      this.isLoading = false
      this.calSummaryBox()
    },
    // beautifyData() {
    //   this.items = this.items.filter(i => {
    //     if (i.payoutStatus === campaignConfig.payoutStatus.CONFIRMED) {
    //       return true
    //     }
    //     if (i.lockedCOGS === true || i.lockedCOGS === false) {
    //       return true
    //     }
    //     return false
    //   })
    //   this.items = this.items.map(item => {
    //     item.campaignType = campaignHelper.getProductName(item.campaignType)
    //     item.campaignStatusDisplay = campaignHelper.getStageName(item.status);
    //     item.clientName = this.getClientName(item.clientID);
    //     item.AM = this.AM.filter(am => item.assignedTo && item.assignedTo.includes(am.id)).map(am => am.name).join(', ')
    //     item.CC = this.CC.filter(cc => item.assignedTo && item.assignedTo.includes(cc.id)).map(cc => cc.name).join(', ')
    //     let campaignClient = this.allClients.find(client => client.id === item.clientID)
    //     item.markupCOGS = campaignHelper.getMarkupCOGS(item.ioNumbers, campaignClient)
    //     item.target = item.markupCOGS || Math.floor(item.budget * 0.3)
    //     item.cogsExcess = this.getExcessCOGS(item)
    //     item.startDateEdit = false
    //     item.endDateEdit = false
    //     return item
    //   })
    // },
    async getUsers() {
      try {
        let response = null
        // get clients
        await this.$store.dispatch('client/getClients')
        // Get all AM by role
        response = await userAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
        if (response) {
          this.AM = response.users
          this.AM = this.AM.map(am => {
            am.name = `${am.firstName} ${am.lastName}`
            return am
          })
        }
        this.AM.unshift({id: '', name: 'All Team'})
        // Get all CC by role
        response = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
        if (response) {
          this.CC = response.users
          this.CC = this.CC.map(cc => {
            cc.name = `${cc.firstName} ${cc.lastName}`
            return cc
          })
          this.CC.unshift({id: '', name: 'All Team'})
        }
      } catch (error) {
        // Request failed.
        console.log('error', error);
        return false
      }
    },
    getClientName(id) {
      let result = null;
      this.allClients.forEach(item => {
        if (item.id === id) {
          if (item.group) {
            result = item.group.Name || item.name
          } else {
            result = item.name
          }
        }
      });
      return result;
    },
    // async saveChanges() {
    //   this.$swal({
    //     title: 'Double Check!',
    //     text: 'Make sure you filled all the required information',
    //     confirmButtonText: 'Confirm',
    //     type: 'info',
    //     showCancelButton: true,
    //     showCloseButton: true
    //   }).then(async (result) => {
    //     if (result.value) {
    //       this.isLoading = true;
    //       // Submit request to save updated campaign data
    //       let updateDatas = []
    //       this.filteredItems.map(item => {
    //         if (item.editData) {
    //           updateDatas.push({
    //             id: item.id,
    //             startDate: item.startDate,
    //             endDate: item.endDate
    //           })
    //         }
    //       })
    //       await this.$store.dispatch('campaign/updateCampaignByIds', updateDatas)
    //       this.isLoading = false;
    //       if (!this.campaignUpdated) {
    //         this.$swal({
    //           text: 'Error Saving Campaigns.',
    //           type: 'error'
    //         });
    //         return
    //       }
    //       // Show success message
    //       this.$swal({
    //         text: 'Successfully Saved.',
    //         type: 'success'
    //       });
    //       this.resetEdit()
    //     }
    //   });
    // },
    // resetEdit() {
    //   this.resetEditFields(this.filteredItems, [
    //     'startDate',
    //     'endDate'
    //   ])
    // },
    async changeLock(item, status) {
      const lockTxt = status ? 'Lock' : 'Unlock'
      this.$swal({
        title: `Are you sure to ${lockTxt}?`,
        icon: 'warning',
        confirmButtonText: lockTxt,
        showCancelButton: true
      }).then(async (result) => {
        if (result.value) {
          const updateData = [
            {
              id: item.campaignID,
              lockedCOGS: status
            }
          ]
          await this.$store.dispatch('campaign/updateCampaignByIds', updateData)
          if (!this.campaignUpdated) {
            this.$swal({
              text: 'Error Campaign Update.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: `Successfully Updated.`,
            type: 'success'
          });
          item.lockedCOGS = status
          // this.getCampaigns()
        }
      })
    },
    async resetFilter() {
      let oldYear = this.selectedFilter.activeYear
      this.selectedFilter = {
        AM: '',
        CC: '',
        startDate: '',
        endDate: '',
        locked: false,
        text: '',
        activeYear: oldYear
      }
      this.getCampaignCogs(true)
    },
    searchFilter() {
      this.filteredItems = utils.func.refreshJSON(this.items)
      this.filteredItems = this.filteredItems.map(item => {
        if (this.selectedFilter.AM) {
          item.data = item.data.filter(dItem => {
            let AMs = dItem.AM.map(a => a.id)
            return AMs && AMs.includes(this.selectedFilter.AM)
          })
        }
        if (this.selectedFilter.CC) {
          item.data = item.data.filter(dItem => {
            let CCs = dItem.CC.map(a => a.id)
            return CCs && CCs.includes(this.selectedFilter.CC)
          })
        }
        if (this.selectedFilter.startDate) {
          item.data = item.data.filter(dItem => {
            return this.formatYmd(dItem.createdAt) >= this.selectedFilter.startDate
          })
        }
        if (this.selectedFilter.endDate) {
          item.data = item.data.filter(dItem => {
            return this.formatYmd(dItem.createdAt) <= this.selectedFilter.endDate
          })
        }
        if (this.selectedFilter.locked) {
          item.data = item.data.filter(dItem => dItem.lockedCOGS)
        }
        if (this.selectedFilter.text) {
          item.filter.search = this.selectedFilter.text
        }
        return item
      })
      this.getTotalSummary()
      this.calSummaryBox()
      // if (this.selectedFilter.CC) {
      //   this.filteredItems = this.filteredItems.filter(item => (item.assignedTo && item.assignedTo.includes(this.selectedFilter.CC)))
      // }
      // if (this.selectedFilter.campaignType) {
      //   if (this.selectedFilter.campaignType === -1) {
      //     this.filteredItems = this.filteredItems.filter(item => {
      //       if (item.campaignType) {
      //         return !this.campaignTypeDisplayFilter.some(v => item.campaignType.includes(v.value))
      //       } else return true
      //     })
      //     this.filteredItems = this.filteredItems.filter(item => !item.campaignType)
      //   } else {
      //     this.filteredItems = this.filteredItems.filter(item => (item.campaignType && item.campaignType === this.selectedFilter.campaignType))
      //   }
      // }
      // if (this.selectedFilter.startDate) {
      //   this.filteredItems = this.filteredItems.filter(item => item.startDate >= this.selectedFilter.startDate)
      // }
      // if (this.selectedFilter.endDate) {
      //   this.filteredItems = this.filteredItems.filter(item => item.endDate <= this.selectedFilter.endDate)
      // }
      // if (this.selectedFilter.locked) {
      //   this.filteredItems = this.filteredItems.filter(item => item.lockedCOGS)
      // }
    },
    async showPairedAdminViewDialog(campaign) {
      this.pairedCampaign = Object.assign({}, {
        id: campaign.campaignID
      })
      this.pairedInfAdminViewDialog = true
    },
    getFiltered(filtered) {
      if (!filtered.length) return
      let qName = filtered[0].yearQuarter
      // get filtered total values
      let qIdex = this.filteredItems.findIndex(f => f.name === qName)
      if (!this.filteredItems[qIdex]) return
      this.filteredItems[qIdex].totalValues = {
        budget: 0,
        cappedCOGS: 0,
        cogsTotal: 0,
        cogsInf: 0,
        cogsOthers: 0,
        cogsInfPercentage: 0,
        cogsExcess: 0,
        completedAmt: 0,
        pendingAmt: 0
      }
      if (filtered.length > 0) {
        filtered.map(f => {
          this.filteredItems[qIdex].totalValues.budget += f.budget ? Number(f.budget) : 0
          this.filteredItems[qIdex].totalValues.cappedCOGS += f.cappedCOGS ? Number(f.cappedCOGS) : 0
          this.filteredItems[qIdex].totalValues.cogsTotal += f.cogsTotal ? Number(f.cogsTotal) : 0
          this.filteredItems[qIdex].totalValues.cogsInf += f.cogsInf ? Number(f.cogsInf) : 0
          this.filteredItems[qIdex].totalValues.cogsOthers += f.cogsOthers ? Number(f.cogsOthers) : 0
          this.filteredItems[qIdex].totalValues.cogsInfPercentage += f.cogsInfPercentage ? Number(f.cogsInfPercentage) : 0
          this.filteredItems[qIdex].totalValues.cogsExcess += f.cogsExcess ? Number(f.cogsExcess) : 0
          this.filteredItems[qIdex].totalValues.completedAmt += f.completedAmt ? Number(f.completedAmt) : 0
          this.filteredItems[qIdex].totalValues.pendingAmt += f.pendingAmt ? Number(f.pendingAmt) : 0
        })
        this.filteredItems[qIdex].totalValues.budget = this.filteredItems[qIdex].totalValues.budget.toFixed(2)
        this.filteredItems[qIdex].totalValues.cappedCOGS = this.filteredItems[qIdex].totalValues.cappedCOGS.toFixed(2)
        this.filteredItems[qIdex].totalValues.cogsTotal = this.filteredItems[qIdex].totalValues.cogsTotal.toFixed(2)
        this.filteredItems[qIdex].totalValues.cogsInf = this.filteredItems[qIdex].totalValues.cogsInf.toFixed(2)
        this.filteredItems[qIdex].totalValues.cogsOthers = this.filteredItems[qIdex].totalValues.cogsOthers.toFixed(2)
        this.filteredItems[qIdex].totalValues.cogsExcess = (this.filteredItems[qIdex].totalValues.cogsExcess).toFixed(2)
        if (this.filteredItems[qIdex].totalValues.cogsInfPercentage > 0) {
          this.filteredItems[qIdex].totalValues.cogsInfPercentage = (this.filteredItems[qIdex].totalValues.cogsInfPercentage / filtered.length).toFixed(2)
        }
      }
    },
    getExcessCOGS(item) {
      if (Number(item.target) > 0) {
        return Number(item.target) - Number(item.cogs)
      }
      return 0
    },
    formatDecimal(value) {
      return parseFloat(value).toFixed(2)
    },
    formatMonth(date) {
      if (!date) return '';
      return moment(date).format('MMM YYYY');
    },
    formatYmd(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD');
    },
    getCOGSExcessColor(cogsExcess) {
      if (cogsExcess < 0) {
        return 'cogs-red'
      } else if (cogsExcess > 0) {
        return 'cogs-green'
      } else {
        return ''
      }
    },
    getCOGSExcessSign(cogsExcess) {
      if (cogsExcess < 0) {
        return '- $' + Math.abs(cogsExcess)
      } else if (cogsExcess > 0) {
        return '+ $' + Math.abs(cogsExcess)
      } else {
        return '$' + 0
      }
    },
    openQuarterUpdateModal(selectedCOGS) {
      this.selectedCOGS = selectedCOGS
      this.quarterUpdateialog = true
    },
    getUsersDisplay(AM) {
      return AM.map(user => user.firstName).join(', ')
    },
    async reloadManually(campaignID) {
      this.isLoading = true
      await this.$store.dispatch('campaign/updateCampaignCogsByCampaignID', [{ campaignID }])
      this.getCampaignCogs()
    },
    openColSettingsModal() {
      this.tableColsItems = []
      let tmpStatuses = {}
      if (Object.keys(this.colStatuses).length) {
        tmpStatuses = Object.assign({}, this.colStatuses)
      } else {
        this.headers.map(header => {
          tmpStatuses[header.value] = true
        })
      }
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(this.headers)) {
        if (value.text) {
          this.tableColsItems.push({
            title: value.text,
            key: value.value,
            value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
          })
        }
      }
      this.colSettingsDialog = true
    },
    async updateTableCols(items) {
      let columns = this.colStatuses
      items.map(item => {
        columns[item.key] = item.value
      })
      let tableSettings = {}
      if (this.userProfile.tableSettings) {
        tableSettings = this.userProfile.tableSettings
      }
      tableSettings.campaignCogsCols = Object.assign({}, columns)
      let updateData = {
        id: this.currentUserID,
        tableSettings
      }
      await userAPIs.editUser(updateData)
      // localStorage.setItem('MasterListCols', JSON.stringify(columns))
      this.colStatuses = Object.assign({}, columns)
      this.colSettingsDialog = false
    },
    async getUserProfile() {
      let resp = await userAPIs.getUser(this.currentUserID)
      if (resp && resp.id) {
        this.userProfile = resp
      }
    },
    openProjectedCogsDialog() {
      this.projectedCogsDialog = true
    },
    getTotalSummary() {
      this.totalSummary.projectedCogs = 0
      this.totalSummary.projectedCogsForMonth = 0
      this.totalSummary.avgCOGS = 0
      let lockedAmts = 0
      let lockedCounts = 0
      let shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      // let currentYear = moment().format('YYYY')
      let currentMonthYear = moment().format('MMM') + '' + moment().format('YYYY')
      let matchMonths = shortMonths.map(m => `${m}${this.selectedFilter.activeYear}`)
      let revsForMonthYear = matchMonths.map(m => {
        return {
          month: m,
          amount: 0,
          totalAmt: 0
        }
      })
      let processItems = []
      this.filteredItems.map(fItem => {
        if (fItem.data) {
          fItem.data.map(i => {
            processItems.push(i)
          })
        }
      })
      // rev for current month year summary boxes based on filtered data
      for (let item of processItems) {
        if (item.monthlyRates) {
          for (let [key, value] of Object.entries(item.monthlyRates)) {
            if (key === currentMonthYear) {
              // current month year (MMM-YYYY)
              this.totalSummary.projectedCogsForMonth += parseFloat(value)
            }
          }
        }
        if (item.pendingAmt) {
          this.totalSummary.projectedCogs += Number(item.pendingAmt)
        }
        if (item.lockedCOGS) {
          lockedAmts += Number(item.cogsInfPercentage)
          lockedCounts += 1
        }
      }
      if (lockedAmts > 0) {
        this.totalSummary.avgCOGS = (lockedAmts / lockedCounts).toFixed(2)
      }
      // rev month year lists based on all data
      for (let item of processItems) {
        if (item.monthlyRates) {
          for (let [key, value] of Object.entries(item.monthlyRates)) {
            let revMYIdx = revsForMonthYear.findIndex(rev => rev.month === key)
            if (revMYIdx !== -1) {
              revsForMonthYear[revMYIdx].amount += parseFloat(value)
            }
          }
        }
      }
      // set total cogs
      this.filteredItems.map(f => {
        for (let data of f.data) {
          let createdMonth = moment(data.createdAt).format('MMMYYYY')
          let revMYIdx = revsForMonthYear.findIndex(rev => rev.month === createdMonth)
          if (revMYIdx !== -1) {
            revsForMonthYear[revMYIdx].totalAmt += parseFloat(data.cogsTotal)
          }
        }
        this.getFiltered(f.data)
      })
      revsForMonthYear = revsForMonthYear.map(rm => {
        rm.month = rm.month.replace(this.selectedFilter.activeYear.toString(), ' ' + this.selectedFilter.activeYear)
        rm.amount = parseFloat(parseFloat(rm.amount, 2).toFixed(2))
        rm.totalAmt = parseFloat(parseFloat(rm.totalAmt, 2).toFixed(2))
        return rm
      })
      this.totalSummary.revsForMonthYear = revsForMonthYear
    },
    roundDec(num) {
      if (num) {
        return Number(num).toFixed(2)
      }
      return num
    },
    exportReport(item) {
      this.isLoading = true
      campaignAPIs
        .exportCampaignCogs(item.data)
        .then(response => {
          this.isLoading = false;
          const blob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          FileSaver.saveAs(blob, `Campaign_Cogs_${item.title}_${moment().format('X')}.xlsx`)
        })
        .catch(error => {
          // Update submitting status
          this.isLoading = false;
          // Request failed.
          console.log('error', error);
          this.$swal({
            text: error,
            type: 'error'
          });
        });
    },
    openActiveYearDialog(campaigns) {
      this.editCampaigns = Object.assign([], campaigns)
      this.activeYearDialog = true
    },
    calSummaryBox() {
      let newItems = utils.func.refreshJSON(this.items)
      newItems = newItems.map(item => {
        if (this.selectedFilter.AM) {
          item.data = item.data.filter(dItem => {
            let AMs = dItem.AM.map(a => a.id)
            return AMs && AMs.includes(this.selectedFilter.AM)
          })
        }
        if (this.selectedFilter.CC) {
          item.data = item.data.filter(dItem => {
            let CCs = dItem.CC.map(a => a.id)
            return CCs && CCs.includes(this.selectedFilter.CC)
          })
        }
        return item
      })
      newItems.map((item, index) => {
        // get filtered total values
        item.totalValues = {
          budget: 0,
          cappedCOGS: 0,
          cogsTotal: 0,
          cogsInf: 0,
          cogsOthers: 0,
          cogsInfPercentage: 0,
          cogsExcess: 0,
          completedAmt: 0,
          pendingAmt: 0
        }
        item.data.map(data => {
          item.totalValues.budget += data.budget ? Number(data.budget) : 0
          item.totalValues.cappedCOGS += data.cappedCOGS ? Number(data.cappedCOGS) : 0
          item.totalValues.cogsTotal += data.cogsTotal ? Number(data.cogsTotal) : 0
          item.totalValues.cogsInf += data.cogsInf ? Number(data.cogsInf) : 0
          item.totalValues.cogsOthers += data.cogsOthers ? Number(data.cogsOthers) : 0
          item.totalValues.cogsInfPercentage += data.cogsInfPercentage ? Number(data.cogsInfPercentage) : 0
          item.totalValues.cogsExcess += data.cogsExcess ? Number(data.cogsExcess) : 0
          item.totalValues.completedAmt += data.completedAmt ? Number(data.completedAmt) : 0
          item.totalValues.pendingAmt += data.pendingAmt ? Number(data.pendingAmt) : 0
        })
        item.totalValues.budget = item.totalValues.budget.toFixed(2)
        item.totalValues.cappedCOGS = item.totalValues.cappedCOGS.toFixed(2)
        item.totalValues.cogsTotal = item.totalValues.cogsTotal.toFixed(2)
        item.totalValues.cogsInf = item.totalValues.cogsInf.toFixed(2)
        item.totalValues.cogsOthers = item.totalValues.cogsOthers.toFixed(2)
        item.totalValues.cogsExcess = (item.totalValues.cogsExcess).toFixed(2)
        if (item.totalValues.cogsInfPercentage > 0) {
          item.totalValues.cogsInfPercentage = (item.totalValues.cogsInfPercentage / item.data.length).toFixed(2)
        }
        return item
      })
      this.summaryItems = Object.assign([], newItems)
    }
  }
}
</script>
<style scoped>
  .date-divider {
    width: 30px;
    text-align: center;
    padding-top: 10px;
  }
  .filter-area {
    justify-content: right;
  }
  .summary-chip {
    font-size: 14px!important;
  }
  .cogs-red {
    color: red;
  }
  .cogs-green {
    color: green;
  }
  .campaign-cogs-section .action-section {
    padding: 0 20px!important;
  }
  .campaign-cogs-section .action-section > .action-group-section {
   padding-top: 25px;
  }
</style>



// WEBPACK FOOTER //
// DataTable.vue?d86d53c0